import * as actionTypes from '../../constants/actionTypes';

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_SCHEDULE_DROPDOWN_DATA_ERROR:
    case actionTypes.FETCH_SCHEDULE_DROPDOWN_DATA_SUCCESS:
      if (action.payload.type === 'kit') {
        return action.payload.list.map(data => {
          return {
            ...data,
            label: data.type,
            value: data.uuid,
          };
        });
      }
      return state;
    default:
      return state;
  }
}
